<template>
  <main class="flex h-screen">

    <!-- SIDEBAR -->
    <aside class="hidden md:flex lg:w-72 md:w-20 h-full bg-[#E87055] dark:bg-[#2c2c2c]
      flex flex-col text-white dark:text-gray-100 text-xl font-semibold overflow-hidden"
      :style="{ fontFamily: `'Syne', sans-serif` }">

      <!-- HEADER -->
      <header class="flex flex-col lg:flex-row items-center justify-center lg:justify-start
        h-24 gap-2 lg:gap-4 px-2 lg:px-6 py-4 my-2">

        <div class="w-14 h-14 lg:w-16 lg:h-16 rounded-lg backdrop-blur-md
          bg-white/30 dark:bg-white/10 flex items-center justify-center
          shadow-lg border border-white/30 dark:border-white/20">

          <img src="../../assets/logo.png" class="w-9 h-9 lg:w-11 lg:h-11" />
        </div>

        <p class="hidden lg:block text-2xl font-semibold">IWC</p>
      </header>

      <div class="h-[1px] bg-white/30 dark:bg-white/20 mx-6"></div>

      <!-- MENU -->
      <nav class="flex flex-col gap-2 px-2 lg:px-4 mt-4">
        <button class="flex items-center justify-center lg:justify-start gap-3
          px-2 lg:px-4 py-3 rounded-lg hover:bg-white/20">
          <receiptIcon class="w-7 h-7 lg:w-8 lg:h-8" />

          <span class="hidden lg:inline text-lg font-medium">
            Service Invoice
          </span>
        </button>
      </nav>

      <div class="flex-1"></div>

      <!-- SETTINGS (SUPER ONLY) -->
      <div v-if="isSuperUser" class="px-2 lg:px-4 mb-2">
        <button class="w-full flex items-center justify-center lg:justify-start gap-2
          px-2 lg:px-3 py-2 rounded-md hover:bg-white/20" @click="openSettings">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 lg:w-6 lg:h-6">
            <path
              d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM12 3.311L4.5 7.65311V16.3469L12 20.689L19.5 16.3469V7.65311L12 3.311ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" />
          </svg>

          <span class="hidden lg:inline text-base font-medium">
            Settings
          </span>
        </button>
      </div>

      <div class="h-[1px] bg-white/30 dark:bg-white/20 mx-6"></div>

      <!-- FOOTER -->
      <footer class="flex flex-col lg:flex-row items-center justify-between
        px-2 lg:px-6 py-4 h-20 bg-white/10 dark:bg-gray-900/50
        border-t border-white/20 dark:border-gray-700">

        <div class="flex items-center gap-2 lg:gap-4">
          <accountIcon class="w-8 h-8 lg:w-9 lg:h-9" />

          <div class="hidden lg:flex flex-col leading-tight">
            <span class="truncate">{{ userData.name }}</span>
            <span class="text-sm text-white/70 dark:text-gray-400">
              {{ userData.role }}
            </span>
          </div>
        </div>

        <button @click="logout" class="p-2 rounded-lg hover:bg-white/20">
          <logoutIcon class="w-6 h-6 lg:w-7 lg:h-7" />
        </button>

      </footer>

    </aside>

    <!-- SETTINGS MODAL -->
    <SettingsModal :show="showSettings" :activeSetting="activeSetting" @close="closeSettings"
      @set-active="setActiveSetting" />

  </main>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import SettingsModal from "../modals/Settings/SettingsModal.vue";
import logoutIcon from "../svg/logoutSvgIcon.vue";
import receiptIcon from "../svg/receiptIcon.vue";
import accountIcon from "../svg/accountIcon.vue";

export default {
  components: {
    logoutIcon,
    receiptIcon,
    accountIcon,
    SettingsModal,
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const userData = computed(() => store.state.userData);

    // 👑 ROLE CHECK
    const isSuperUser = computed(() => userData.value?.role === "super");

    // SETTINGS STATE
    const showSettings = ref(false);
    const activeSetting = ref("payee");

    const openSettings = () => (showSettings.value = true);
    const closeSettings = () => (showSettings.value = false);

    const setActiveSetting = (key) => {
      activeSetting.value = key;
    };

    const logout = () => {
      localStorage.clear();
      router.push("/");
    };

    return {
      userData,
      showSettings,
      activeSetting,
      openSettings,
      closeSettings,
      setActiveSetting,
      logout,
      isSuperUser,
    };
  },
};
</script>